import { ComplexParamsBundle } from '../../../../../../Detail/types';
import './index.css';
import TransactionItemStructure from '../../../../../../../components/TransactionItem';
import { colors } from '../../../../../../../colors';

interface Props {
  complexParamsBundle: ComplexParamsBundle;
  isFirst: boolean;
}

const ComplexParamsBundleComponent = (props: Props) => {
  const { complexParamsBundle, isFirst } = props;

  return (
    <TransactionItemStructure
      circleLabel={'CP'}
      circleColor={'rgb(7, 72, 121)'}
      circleSize={70}
      contentWidth="auto"
      content={
        <div
          style={{
            display: 'grid',
            gridTemplateRows: '1fr',
            gridTemplateColumns: '1fr 1fr',
            color: colors.white,
            padding: 16,
            paddingLeft: 32,
            columnGap: 32,
          }}
        >
          <div
            style={{
              gridRow: '1 / 2',
              gridColumn: '1 / 2',
            }}
          >
            <span className="complex-params-bundle-content-label">
              Complex Params
            </span>
            {/** Cbrt */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                Cbrt:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.complexParams.cbrt}
              </span>
            </div>
            {/** ShorterT Interval */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                ShorterT Interval:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.complexParams.shorterTimeFrameInterval}
              </span>
            </div>
            {/** Support Cbrt Range */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                Cbrt Range:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.complexParams.supportCbrtRange
                  ? 'Yes'
                  : 'No'}
              </span>
            </div>
            {/** Support Mrc State */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                Mrc State:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.complexParams.supportMrcState
                  ? 'Yes'
                  : 'No'}
              </span>
            </div>
          </div>
          <div
            style={{
              gridRow: '1 / 2',
              gridColumn: '2 / 3',
            }}
          >
            <span className="complex-params-bundle-content-label">
              TimeFrames
            </span>
            {/** Higher TimeFrame */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                HigherT:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.timeFrames.higher}
              </span>
            </div>
            {/** Shorter TimeFrame */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                ShorterT:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.timeFrames.shorter}
              </span>
            </div>
            {/** Multi TimeFrame */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                MultiT:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.timeFrames.multiOrder}
              </span>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ComplexParamsBundleComponent;
